<template>
  <div class="content-box">
    <div class="login-top">
      <div class="inline logo">
        <img src="../assets/logo.png" alt=""/>
      </div>
      <div class="inline go-back" @click="$router.go(-1)">返回</div>
      <span class="inline fr">客服</span>
    </div>
    <div class="content">
      <p>客服电话：400-000-0000</p>
      <p>客服工作时间：周一至周日   08：00-20：00</p>
      <p>客服微信</p>
      <img src="../assets/qrcode.png" alt="">
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      loginForm: {
        mobile: '',
        fpassword: ''
      }
    }
  },
  computed: {
    ...mapState([ 'btnLoading' ])
  },
  methods: {
    handleLogin () {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          // this.submit()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.content{
  padding: 10px;
  p{
    line-height: 60px;
    font-size: 16px;
  }
  img{
    width: 150px;
    height: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/service.vue